import {
  GenericAnalyticsWidgetDataRequestType,
  GenericAnalyticsWidgetType,
  GenericAnalyticsWidgetUIConfigType
} from './analytics'

export enum cartAnalyticsWidgetSet {
  CART_CONVERSION = 'cart_conversion',
  CART_CONVERSION_CHART = 'cart_conversion_chart',
  GENERIC_WIDGET = 'generic',
  CART_MILESTONES = 'milestone_cart'
}

export type CartAnalyticsWidgetType =
  | {
      type: cartAnalyticsWidgetSet.CART_CONVERSION
      data: GenericAnalyticsWidgetType
    }
  | {
      type: cartAnalyticsWidgetSet.CART_CONVERSION_CHART
      data: GenericAnalyticsWidgetType
    }
  | {
      type: cartAnalyticsWidgetSet.GENERIC_WIDGET
      data: GenericAnalyticsWidgetType
    }
  | {
      type: cartAnalyticsWidgetSet.CART_MILESTONES
      data: GenericAnalyticsWidgetType
    }

export type CartNoteErrorType = {
  title: {
    hasError: boolean
    errorMessage: string
  }
  suggestionText: {
    hasError: boolean
    errorMessage: string
  }
}
